var map = {
	"./cancel-button.mp3": "cfdc",
	"./dodon.mp3": "bbbb",
	"./don.mp3": "16a6",
	"./freshtea.mp3": "1a51",
	"./info.mp3": "bf57",
	"./ok-button.mp3": "85db",
	"./open-door.mp3": "ea98",
	"./put-stone.mp3": "e9f9",
	"./receive-chat.mp3": "21ab",
	"./stage-select.mp3": "f44e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ac03";